import { WrapperForm, Input, Dropdown } from "components";
import { MaskHelper } from "helpers";

const CreditCard = (props: any): JSX.Element => {
  const { formik } = props;

  return (
    <>
      {formik.values.billing.formPayment === "credit_card" && (
        <WrapperForm full className="py-1">
          <div className="container-form">
            <div className="row">
              <div className="col-12">
                <Input
                  type="tel"
                  name="billing.cardNumber"
                  label="Número do cartão"
                  value={MaskHelper.creditCardNumber(
                    formik.values.billing.cardNumber
                  )}
                  onChange={e =>
                    formik.setValues((values: any) => ({
                      ...values,
                      billing: {
                        ...values.billing,
                        cardNumber: e.currentTarget.value
                      }
                    }))
                  }
                  error={
                    formik?.touched?.billing?.cardNumber &&
                    formik?.errors?.billing?.cardNumber
                  }
                  required
                />
              </div>
              <div className="col-12">
                <Input
                  type="text"
                  name="billing.cardName"
                  label="Nome do titular"
                  value={formik.values.billing.cardName}
                  onChange={e =>
                    formik.setValues((values: any) => ({
                      ...values,
                      billing: {
                        ...values.billing,
                        cardName: e.currentTarget.value
                      }
                    }))
                  }
                  error={
                    formik?.touched?.billing?.cardName &&
                    formik?.errors?.billing?.cardName
                  }
                  required
                />
              </div>
              <div className="col-12 col-md-6">
                <Input
                  type="tel"
                  name="billing.cardExpiring"
                  label="Validade (MM/AA)"
                  value={MaskHelper.creditCardExpiration(
                    formik.values.billing.cardExpiring
                  )}
                  onChange={e =>
                    formik.setValues((values: any) => ({
                      ...values,
                      billing: {
                        ...values.billing,
                        cardExpiring: e.currentTarget.value
                      }
                    }))
                  }
                  error={
                    formik?.touched?.billing?.cardExpiring &&
                    formik?.errors?.billing?.cardExpiring
                  }
                  required
                />
              </div>
              <div className="col-12 col-md-6">
                <Input
                  type="tel"
                  name="billing.cardCVC"
                  label="Código"
                  value={MaskHelper.creditCardCVC(
                    formik.values.billing.cardCVC
                  )}
                  onChange={e =>
                    formik.setValues((values: any) => ({
                      ...values,
                      billing: {
                        ...values.billing,
                        cardCVC: e.currentTarget.value
                      }
                    }))
                  }
                  error={
                    formik?.touched?.billing?.cardCVC &&
                    formik?.errors?.billing?.cardCVC
                  }
                  required
                />
              </div>
            </div>
          </div>
        </WrapperForm>
      )}
    </>
  );
};

export default CreditCard;
